import {
  generateTask as generateSimple,
  renderTask as renderSimple,
  renderInput as inputSimple,
  checkAnswer as checkSimple,
  renderAnswer as answerSimple,
  renderExplanation as explainSimple,
  renderUserAnswer as userSimple
} from "./podtemat1_liniowe_types/SolveSimpleLinearEquationTask";

import {
  generateTask as generateTwoSided,
  renderTask as renderTwoSided,
  renderInput as inputTwoSided,
  checkAnswer as checkTwoSided,
  renderAnswer as answerTwoSided,
  renderExplanation as explainTwoSided,
  renderUserAnswer as userTwoSided
} from "./podtemat1_liniowe_types/SolveTwoSidedLinearEquationTask";

import {
  generateTask as generateWithParentheses,
  renderTask as renderWithParentheses,
  renderInput as inputWithParentheses,
  checkAnswer as checkWithParentheses,
  renderAnswer as answerWithParentheses,
  renderExplanation as explainWithParentheses,
  renderUserAnswer as userWithParentheses
} from "./podtemat1_liniowe_types/SolveLinearEquationWithParenthesesTask";

import {
  generateTask as generateFractions,
  renderTask as renderFractions,
  renderInput as inputFractions,
  checkAnswer as checkFractions,
  renderAnswer as answerFractions,
  renderExplanation as explainFractions,
  renderUserAnswer as userFractions
} from "./podtemat1_liniowe_types/LinearEquationFractionsTask";

import {
  generateTask as generateQuadratic,
  renderTask as renderQuadratic,
  renderInput as inputQuadratic,
  checkAnswer as checkQuadratic,
  renderAnswer as answerQuadratic,
  renderExplanation as explainQuadratic,
  renderUserAnswer as userQuadratic
} from "./podtemat1_liniowe_types/SolveQuadraticsThatReduceToLinearTask";

import {
  generateTask as generateTypeCheck,
  renderTask as renderTypeCheck,
  renderInput as inputTypeCheck,
  checkAnswer as checkTypeCheck,
  renderAnswer as answerTypeCheck,
  renderExplanation as explainTypeCheck,
  renderUserAnswer as userTypeCheck
} from "./podtemat1_liniowe_types/EquationTypeIdentificationTask";

export function generateTasks() {
  return [
    generateSimple(),
    generateTwoSided(),
    generateWithParentheses(),
    generateFractions(),
    generateQuadratic(),
    generateTypeCheck()
  ];
}

export function renderTask(task) {
  switch (task.type) {
    case "SolveSimpleLinearEquationTask":
      return renderSimple(task);
    case "SolveTwoSidedLinearEquationTask":
      return renderTwoSided(task);
    case "SolveLinearEquationWithParenthesesTask":
      return renderWithParentheses(task);
    case "LinearEquationFractionsTask":
      return renderFractions(task);
    case "SolveQuadraticsThatReduceToLinearTask":
      return renderQuadratic(task);
    case "EquationTypeIdentificationTask":
      return renderTypeCheck(task);
  }
}

export function renderInput(task, userInput, onChange, disabled) {
  switch (task.type) {
    case "SolveSimpleLinearEquationTask":
      return inputSimple(task, userInput, onChange, disabled);
    case "SolveTwoSidedLinearEquationTask":
      return inputTwoSided(task, userInput, onChange, disabled);
    case "SolveLinearEquationWithParenthesesTask":
      return inputWithParentheses(task, userInput, onChange, disabled);
    case "LinearEquationFractionsTask":
      return inputFractions(task, userInput, onChange, disabled);
    case "SolveQuadraticsThatReduceToLinearTask":
      return inputQuadratic(task, userInput, onChange, disabled);
    case "EquationTypeIdentificationTask":
      return inputTypeCheck(task, userInput, onChange, disabled);
  }
}

export function checkAnswer(task, userInput) {
  switch (task.type) {
    case "SolveSimpleLinearEquationTask":
      return checkSimple(task, userInput);
    case "SolveTwoSidedLinearEquationTask":
      return checkTwoSided(task, userInput);
    case "SolveLinearEquationWithParenthesesTask":
      return checkWithParentheses(task, userInput);
    case "LinearEquationFractionsTask":
      return checkFractions(task, userInput);
    case "SolveQuadraticsThatReduceToLinearTask":
      return checkQuadratic(task, userInput);
    case "EquationTypeIdentificationTask":
      return checkTypeCheck(task, userInput);
  }
}

export function renderAnswer(task) {
  switch (task.type) {
    case "SolveSimpleLinearEquationTask":
      return answerSimple(task);
    case "SolveTwoSidedLinearEquationTask":
      return answerTwoSided(task);
    case "SolveLinearEquationWithParenthesesTask":
      return answerWithParentheses(task);
    case "LinearEquationFractionsTask":
      return answerFractions(task);
    case "SolveQuadraticsThatReduceToLinearTask":
      return answerQuadratic(task);
    case "EquationTypeIdentificationTask":
      return answerTypeCheck(task);
  }
}

export function renderExplanation(task) {
  switch (task.type) {
    case "SolveSimpleLinearEquationTask":
      return explainSimple(task);
    case "SolveTwoSidedLinearEquationTask":
      return explainTwoSided(task);
    case "SolveLinearEquationWithParenthesesTask":
      return explainWithParentheses(task);
    case "LinearEquationFractionsTask":
      return explainFractions(task);
    case "SolveQuadraticsThatReduceToLinearTask":
      return explainQuadratic(task);
    case "EquationTypeIdentificationTask":
      return explainTypeCheck(task);
  }
}

export function renderUserAnswer(task, userAnswer) {
  switch (task.type) {
    case "SolveSimpleLinearEquationTask":
      return userSimple(userAnswer);
    case "SolveTwoSidedLinearEquationTask":
      return userTwoSided(userAnswer);
    case "SolveLinearEquationWithParenthesesTask":
      return userWithParentheses(userAnswer);
    case "LinearEquationFractionsTask":
      return userFractions(userAnswer);
    case "SolveQuadraticsThatReduceToLinearTask":
      return userQuadratic(userAnswer);
    case "EquationTypeIdentificationTask":
      return userTypeCheck(userAnswer);
    default:
      return null;
  }
}
